export default async function getSounds({ context, nextMiddleware }) {
  console.log('getSounds');
  try {
    if (!context.store.soundStore.isSounds) {
      let sounds = ['alert', 'click', 'click1', 'message', 'tap'];
      await context.store.soundStore.setSounds(sounds);
    }
  } catch (e) {
    console.error(e);
    return context.next(false);
  }
  return nextMiddleware();
}
